import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../../../lib/utilities';
import { ServiceWheelAlignment } from './service_fitting_station/service_wheel_alignment';
import { ServiceFitting } from './service_fitting_station/service_fitting';
import { ServiceFittingStationMainRow } from './service_fitting_station/service_fitting_station_main_row';
import { ServiceCalloutFee } from './service_fitting_station/service_callout_fee';

export function ServiceFittingStation(props) {
    const services = [
        <ServiceFittingStationMainRow
            fsTotalPrice={props.fsTotalPrice}
            fittingStationStreet={props.fittingStationStreet}
            fittingStationSuburb={props.fittingStationSuburb}
            sidebarPostcode={props.sidebarPostcode}
            onChangeStationClick={props.onChangeStationClick}
            onRemoveStationClick={props.onRemoveStationClick}
            fsDetailsVisible={props.fsDetailsVisible}
            onShowFsDetailsClick={props.onShowFsDetailsClick}
            currencyIsoCode={props.currencyIsoCode}
            isMobileFitter={props.isMobileFitter}
            key={'ServiceFittingStationMainRow'}
        />
    ];

    if (props.fsDetailsVisible && props.hasFitting) {
        services.push(
            <ServiceFitting
                quantity={props.quantity}
                fittingPrice={props.fittingPrice}
                currencyIsoCode={props.currencyIsoCode}
                loading={props.loading}
                key="ServiceFitting"
            />
        );
    }

    if (props.fsDetailsVisible && props.calloutFeePrice && props.calloutFeePrice > 0) {
        services.push(
            <ServiceCalloutFee
                calloutFee={props.calloutFeePrice}
                currencyIsoCode={props.currencyIsoCode}
                loading={props.loading}
                key="ServiceCalloutFee"
            />
        );
    }

    if (props.fsDetailsVisible
        && props.hasWheelAlignment
        && props.wheelAlignmentPrice > 0) {
        services.push(
            <ServiceWheelAlignment
                wheelAlignmentQuantity={props.wheelAlignmentQuantity}
                wheelAlignmentPrice={props.wheelAlignmentPrice}
                currencyIsoCode={props.currencyIsoCode}
                loading={props.loading}
                onMoreInfoClick={props.onMoreInfoWheelAlignmentClick}
                key="ServiceWheelAlignment"
            />
        );
    }

    return services; 
}

ServiceFittingStation.propTypes = {
    fsTotalPrice: PropTypes.number.isRequired,
    fittingStationStreet: PropTypes.string.isRequired,
    fittingStationSuburb: PropTypes.string.isRequired,
    sidebarPostcode: PropTypes.string.isRequired,
    onChangeStationClick: PropTypes.func.isRequired,
    onRemoveStationClick: PropTypes.func.isRequired,
    quantity: PropTypes.number.isRequired,
    fittingPrice: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    wheelAlignmentQuantity: PropTypes.number.isRequired,
    wheelAlignmentPrice: PropTypes.number.isRequired,
    onMoreInfoWheelAlignmentClick: PropTypes.func.isRequired,
    onShowFsDetailsClick: PropTypes.func,
    fsDetailsVisible: PropTypes.bool.isRequired,
    isMobileFitter: PropTypes.bool.isRequired,
    hasFitting: PropTypes.bool,
    hasWheelAlignment: PropTypes.bool,
};

ServiceFittingStation.defaultProps = {
    hasFitting: false,
    hasWheelAlignment: false,
    onShowFsDetailsClick: noop,
};
